e<template>
  <div>
    <v-card
      tile
      minHeight="72"
      :color="(alert.status === 'unread') ? 'null' : 'grey lighten-2'"
    >
      <v-card-text>
        <v-container>
          <v-row noGutters>
            <v-col cols="1">
              <p
                :class="{'d-none': alert.status === 'unread'}"
                class="dot alert deep-orange darken-2"
              />
            </v-col>
            <v-col cols="11">
              {{ alert.content }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
    props: {
        alert: {
            type: Object,
            required: true,
        },
    },
    computed: {
        notifications() {
            return `${this.network.event.value} ${this.network.event.data}`;
        },
        problem() {
            return `${this.network.event.value} ${this.network.event.data} in ${this.network.networkInfo.name}`;
        },
        icon() {
            return this.chooseIcon();
        },
    },
    methods: {
        chooseIcon() {
            switch (this.network.state) {
                case 'ok':
                    return './infos.svg';
                case 'warning':
                    return './warning.svg';
                default:
                    return null;
            }
        },
    },
};
</script>
